


















































import AppLoading from '@/components/ui/AppLoading.vue'
import { Component, Vue } from 'vue-property-decorator'
import { ConsultarNFUseCase } from '@/usecases/consulta/nf/ConsultarNFUseCase'
import { DadosConsultaNF } from '@/models/DadosConsultaNF'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import { imprimirNfceDaConsulta } from '@/shareds/venda-shareds'

@Component({
	components: {
		AppLoading,
	},
})
export default class ConsultaNF extends Vue {
	loading = true
	imprimindo = false
	dadosConsulta: DadosConsultaNF | null = null
	consultarNFUseCase: ConsultarNFUseCase = new ConsultarNFUseCase()

	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	async created() {
		this.consultarNFUseCase.execute(this.$route.params.chaveDeConsulta)
			.then(dados => this.dadosConsulta = dados)
			.finally(() => this.loading = false)
	}

	async imprimirCupom() {
		this.imprimindo = true
		imprimirNfceDaConsulta(this.$route.params.chaveDeConsulta)
			.finally(() => this.imprimindo = false)
		
	}
}
